export const Constants = {
  AppointmentStatus: {
    IN_REVIEW: "in_review",
    UPCOMING: "upcoming",
    COMPLETED: "completed",
    CANCELLED: "cancelled",
    ONGOING: "ongoing",
  },
};


